import { React, useState, useEffect, useRef } from "react";
import MiscUploadPDFView from "../misc_components/MiscUploadPDFView";
import Footer from "../Footer";
import NavBar from "../NavBar";
import MiscPageTitle from "../misc_components/MiscPageTitle";
import MiscPageMidSection from "../misc_components/MiscPageMidSection";
import HomeScreenHowToUse from "../home_screen/HomeScreenHowToUse";
import MiscWhyUse from "../misc_components/MiscWhyUse";
import MiscPageLookingFor from "../misc_components/MiscPageLookingFor";
import LoadingBar from "react-top-loading-bar";
import { useLocation, ScrollRestoration } from "react-router-dom";
import { PageContext } from "../../App";
import MiscDownloadOnAppStore from "../misc_components/MiscDownloadOnAppStore";
import { BASE_URL } from "../Config";
import UpscaleUploadView from "./UpscaleUploadView";
import MiscFAQ from "../misc_components/MiscFAQ";
import MiscRecommendedPages from "../misc_components/MiscRecommendedPages";

function UpscaleImageMain() {
  //location
  const location = useLocation();
  // Use optional chaining or a guard in case state is undefined
  const { title } = location.state || {
    title: "AI Upscale Image For Free Online",
  };

  //selected files
  const [selectedFiles, setSelectedFiles] = useState([]);
  //show edit screen
  const [showEditFileScreen, setShowEditFileScreen] = useState(false);
  //start processing
  const [startProcessingFiles, setStartProcessingFiles] = useState(false);

  //reference loading bar
  const loadingBarRef = useRef(null);

  //looking for object
  //requires 3 data objects
  //to show keywarded navigation
  const lookingForObject = {
    data1: { link: "/upscale_image", title: "Image Unscaler Tool" },
    data2: { link: "/upscale_image", title: "AI Image Upscaler Online" },
    data3: {
      link: "/upscale_image",
      title: "AI Image Upscaler 4K",
    },
  };

  //use effect to handle the submit button click
  useEffect(() => {
    //check
    if (startProcessingFiles === true) {
      //show file edit screen
      setShowEditFileScreen(true);

      console.log(
        "Start file processing. Number of files: ",
        selectedFiles.length,
      );
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [startProcessingFiles]);

  return (
    <PageContext.Provider
      value={{
        selectedFiles,
        setSelectedFiles,
        startProcessingFiles,
        setStartProcessingFiles,
        setShowEditFileScreen,
      }}
    >
      {/* Scroll to top */}
      <ScrollRestoration />
      {/* Loading Bar */}
      <LoadingBar ref={loadingBarRef} />

      {/*Add title and metadata */}
      <title>{title}</title>
      <meta name="robots" content="index, follow"></meta>
      <link
        rel="canonical"
        href={`${BASE_URL}${lookingForObject.data1.link}`}
      />
      <meta
        name="description"
        content="Upscale images online instantly. Increase image resolution, enhance photo quality and enlarge images without losing clarity using our AI image upscaler."
      ></meta>
      <meta
        name="keywords"
        content="upscale image, image upscaler, ai image upscaler, increase image resolution, enhance image quality, enlarge image online, upscale images online, photo upscaler, image resolution enhancer, image enlarger, ai photo upscaler, upscale image free, image enhancement tool, image quality improver, super resolution image, image upscaler free, upscale image ai, image upscaler 4k, image upscaler 2k, image upscaler HD, image upscaler UHD,"
      ></meta>

      {/* page content */}
      <div>
        {/* Nav Bar */}
        <NavBar />
        {/* Title */}
        <MiscPageTitle title={title} online={true} />
        {/* Upload PDF View */}
        {/* Upload View maxFileSize = 9.9mb */}
        {/* Runpod datauri size limit = 9.9mb */}
        {showEditFileScreen ? (
          <UpscaleUploadView
            maxFileSize={2 * 1024 * 1024}
            allowedFileExtensions={["jpeg", "jpg", "png"]}
          />
        ) : (
          <MiscUploadPDFView
            selectMultiple={false}
            filetype={{
              "image/jpeg": [".jpg", ".jpeg"],
              "image/png": [".png"],
            }}
          />
        )}
        {/* Mid Section */}
        <MiscPageMidSection description="Our upscale image website helps users enhance image resolution and quality effortlessly using advanced image processing technology. With a powerful image upscaler, you can increase the size of low resolution photos while maintaining sharpness, details, and natural colors. This online image upscaling tool is perfect for photographers, designers, e-commerce sellers, marketers, and everyday users who want to improve photo quality without complex editing software. Using an upscale image online solution allows you to enlarge images for websites, social media, presentations, and print materials with professional results. Modern image upscaler tools support popular formats such as JPG, PNG, and WebP and use smart algorithms to reduce blur and pixelation. Whether you want to enhance old photos, prepare high resolution visuals, or optimize images for digital platforms, an upscale image website offers a fast, easy, and reliable way to improve image quality. From creative projects to business use, image upscaling is an essential tool for producing clear, high quality images that look great on any screen." />
        {/* How to use */}
        <HomeScreenHowToUse
          steps={{
            step1: "Select",
            step2: "Offline",
            step3: "Upscale",
            step4: "Download",
          }}
        />
        {/* Why use section */}
        <MiscWhyUse
          title="Upscale Image Tool"
          why_use={[
            {
              title: "Improve Image Resolution and Quality",
              description:
                "This upscale image website helps increase image resolution while preserving details and sharpness. Using an image upscaler improves photo quality without blurring or pixelation.",
            },
            {
              title: "Enhance Low Resolution Photos",
              description:
                "Image upscaling tools are ideal for improving small or low quality images, making them suitable for modern displays and professional use.",
            },
            {
              title: "Perfect for Print and High Resolution Displays",
              description:
                "Our upscale image online tool prepares images for printing, large screens, and presentations by enlarging images with high clarity.",
            },
            {
              title: "Save Time Compared to Manual Editing",
              description:
                "Using an image upscaler online eliminates the need for complex photo editing software, allowing quick and efficient image enhancement.",
            },
            {
              title: "Useful for Designers and Content Creators",
              description:
                "Designers, photographers, and marketers rely on upscale image websites to enhance visuals for websites, ads, and social media.",
            },
            {
              title: "Maintain Natural Colors and Details",
              description:
                "Modern image upscaler tools use smart algorithms to preserve textures, colors, and edges while upscaling images.",
            },
            {
              title: "Supports Multiple Image Formats",
              description:
                "Our upscale image website supports JPG, PNG, WebP, and other formats, making it easy to upscale images of any type.",
            },
            {
              title: "Works Across Devices and Platforms",
              description:
                "Upscale image online tools work seamlessly on desktop and mobile browsers without requiring installation.",
            },
            {
              title: "Enhance Old or Compressed Images",
              description:
                "Image upscaling helps restore clarity in old, scanned, or heavily compressed photos.",
            },
          ]}
        />
        {/* FAQ */}
        <MiscFAQ
          faq_list={[
            {
              title: "What is an image upscaler?",
              description:
                "An image upscaler is a tool that increases an image's dimensions and resolution. Depending on the method used, it can enlarge photos, illustrations, and graphics while attempting to preserve sharpness and visual detail.",
            },
            {
              title: "How can I upscale an image online for free?",
              description:
                "Open the image upscaler on ShivaPDF.com, select your image, choose the available scaling option, and process the file. Download the enlarged image when processing is complete and the tool provides an output.",
            },
            {
              title: "Can I upscale an image without losing quality?",
              description:
                "Upscaling increases image dimensions, but it cannot guarantee that all original details will remain sharp. AI-based upscaling may reconstruct plausible details, while conventional resizing uses interpolation to create additional pixels.",
            },
            {
              title: "What is AI image upscaling?",
              description:
                "AI image upscaling uses machine-learning models to enlarge images and estimate missing visual details. It can improve the appearance of low-resolution photos, although the generated details may not perfectly match the original scene.",
            },
            {
              title: "Can I increase image resolution for free?",
              description:
                "Yes, you can use a free image upscaling tool if the feature is available on ShivaPDF.com. Select your image, choose a supported upscale factor, and download the higher-resolution result subject to any usage limits.",
            },
            {
              title: "Can I upscale an image by 2x?",
              description:
                "If 2x upscaling is supported, the tool doubles the image's width and height. For example, a 1000 × 1000 pixel image becomes 2000 × 2000 pixels, producing four times as many pixels overall.",
            },
            {
              title: "Can I upscale an image by 4x?",
              description:
                "A tool with 4x upscaling increases both the width and height by a factor of four. A 500 × 500 pixel image would become 2000 × 2000 pixels, but the resulting quality depends on the upscaling method and original image.",
            },
            {
              title: "Can I upscale a low-resolution photo?",
              description:
                "Yes, an image upscaler can enlarge low-resolution photos for viewing, sharing, or design projects. Very blurry or heavily pixelated images may still lack enough original information to produce a clear result.",
            },
            {
              title: "Can I make a small image bigger without pixelation?",
              description:
                "Upscaling can reduce the visible blockiness that occurs when small images are enlarged. AI-based methods may improve perceived detail, but no method can guarantee a perfectly sharp result from every low-resolution image.",
            },
            {
              title: "Can I upscale images for printing?",
              description:
                "Upscaling can increase the pixel dimensions of an image for printing. Choose a resolution suitable for the intended print size and check the result at full size, because more pixels do not always mean more authentic detail.",
            },
            {
              title: "Can I upscale an image for social media?",
              description:
                "Yes, an image upscaler can help enlarge images for social media posts, banners, thumbnails, and profile graphics. Check the platform's recommended dimensions and aspect ratio before publishing.",
            },
            {
              title: "Which image formats can I upscale?",
              description:
                "Supported formats depend on the tool. Common image formats include JPG, JPEG, and PNG. Check the file selector on ShivaPDF.com to confirm which input formats are accepted.",
            },
            {
              title: "Will upscaling increase the image file size?",
              description:
                "Upscaling usually increases the number of pixels and may increase the output file size. The final size also depends on the image format, compression level, image content, and export settings.",
            },
            {
              title: "Can I upscale a JPG image?",
              description:
                "Yes, JPG or JPEG images can be upscaled when the tool supports those formats. Because JPEG uses lossy compression, heavily compressed images may still show artifacts after enlargement.",
            },
            {
              title: "Can I upscale a PNG image?",
              description:
                "Yes, PNG images can be enlarged using a compatible image upscaler. If transparency is important, check whether the tool preserves transparent backgrounds in the exported file.",
            },
            {
              title: "Can I upscale an image on my phone?",
              description:
                "You can use a mobile-friendly image upscaler on a compatible iPhone or Android device if the tool supports mobile browsers. Open ShivaPDF.com, select your image, and follow the available resizing options.",
            },
            {
              title: "Can I upscale images on Windows or Mac?",
              description:
                "A browser-based image upscaler can work on compatible Windows and Mac computers. Open ShivaPDF.com in a supported browser, select the image, and use the available upscaling controls.",
            },
            {
              title: "Can I upscale an image without installing software?",
              description:
                "A browser-based image upscaler lets you enlarge images without installing a separate desktop application. The available processing methods and output options depend on the tool's features.",
            },
            {
              title: "Is ShivaPDF's image upscaler free?",
              description:
                "ShivaPDF provides browser-based tools for common file and image tasks. Check the image upscaler page for current availability, maximum image dimensions, supported formats, and any usage restrictions.",
            },
            {
              title: "Can I upscale an image without creating an account?",
              description:
                "You may be able to upscale images without registering if the tool does not require an account. Check the current ShivaPDF page for access requirements and any applicable limits.",
            },
            {
              title: "Why does my upscaled image look blurry?",
              description:
                "An upscaled image may remain blurry if the original contains little detail, motion blur, strong compression, or noise. Try a higher-quality source image and compare the available upscaling settings if the tool offers them.",
            },
            {
              title: "Does image upscaling improve sharpness?",
              description:
                "Image upscaling can improve perceived sharpness depending on the resizing method. AI-based tools may reconstruct edges and textures, but they can also introduce artificial details that were not present in the original.",
            },
            {
              title: "Is it safe to upscale private images online?",
              description:
                "For private images, choose a tool with a clear privacy policy and verified local processing if you want files to remain on your device. Check how images are processed and stored before using an online service for sensitive content.",
            },
            {
              title: "What is the difference between image upscaling and image resizing?",
              description:
                "Image resizing changes an image's dimensions and can make it larger or smaller. Image upscaling specifically increases dimensions, while AI upscaling may also attempt to reconstruct visual details to improve the enlarged result.",
            },
          ]} />
        {/* Download on Appsroe */}
        <MiscDownloadOnAppStore
          id={`https://apps.apple.com/app/id${1598764248}`}
        />
        {/* Looking for section */}
        <MiscPageLookingFor data={lookingForObject} />
        {/* Recommended Tools */}
        <MiscRecommendedPages />
        {/* Footer */}
        <Footer />
      </div>
    </PageContext.Provider>
  );
}

export default UpscaleImageMain;
